import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../admin/Sidebar/Sidebar';
import styles from './Layout.module.css';

const Layout: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);

  const handleToggle = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  return (
    <div className={styles.container}>
      <Sidebar onToggle={handleToggle} />
      <div
        className={`${styles.content} ${
          sidebarCollapsed ? styles.contentCollapsed : styles.contentExpanded
        }`}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
